import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  asNavLink: (link: string): string =>
    `${cleanedFilename(__filename)}-nav-link-${link.replace(/[\W_]+/g, '')}`,
};
